import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { Oracle } from '/screens/';

export default function OraclePage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="logistics integrations, logistics partners, blue yonder"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Logistics Partners | Oracle | Loadsmart"
        description="Our integration with Oracle helps you move more with less by delivering real-time market rates and automated booking natively into your Oracle transportation management system."
        canonical="https://loadsmart.com/integrations/oracle/"
        openGraph={{
          url: 'https://loadsmart.com/integrations/oracle/',
        }}
      />
      <Oracle />
    </>
  );
}
